import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { createHttpLink } from 'apollo-link-http'
import { createUploadLink } from 'apollo-upload-client'
import 'es6-map/implement'
import 'es6-set/implement'
import cookie from 'js-cookie'
import React, { useState } from 'react'
import { ApolloProvider } from 'react-apollo-hooks'
import 'react-app-polyfill/ie11'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ScrollContext } from 'react-router-scroll-4'
import 'string.prototype.startswith'
import { ErrorMessageBox, Hero, Overview, PageNotFound } from './application'
import Ati from './ati'
import { useAuth } from './authContext'
import * as billy from './billy'
import { Overview as Preferences } from './preferences'
import { Overview as Privacy } from './privacy'
import { loadResources, settings, urls } from './resources'
import getText from './resources/strings'
import SelfService from './selfservice'
import { Container } from './styles'

export default () => {
  const { actions, isLoggedIn } = useAuth()
  const [networkError, setNetworkError] = useState(false)

  const settingsLoader = async () => {
    await loadResources(false)
  }

  settingsLoader()

  const trumfRef = billy.getQueryParamValue('tref')
  if (trumfRef) window.localStorage.setItem('partner.trumf.ref', trumfRef)

  const AuthRoute = ({ children, ...props }) => {
    if (!isLoggedIn) {
      window.location = urls.signIn
      return null
    }

    return <Route {...props} render={({ location }) => (isLoggedIn ? children : <Redirect to={`${urls.signIn}?returnUrl=${encodeURIComponent(`${location.pathname}${location.search}`)}`} />)} />
  }

  const WithHero = ({ children }) => (
    <div>
      <Hero />
      {networkError && (
        <Container>
          <ErrorMessageBox message={getText('errors', 'communication')} isError />
        </Container>
      )}
      {children}
    </div>
  )

  const httpLink = createHttpLink({
    uri: `${isLoggedIn ? settings.apiAuthorizedGraphqlUrl : settings.apiOpenGraphqlUrl}?brand=${settings.language}`,
    fetchOptions: { method: 'POST' },
  })

  const authLink = setContext(async (_, { headers }) => {
    const token = await actions.getAccessToken()
    const impersonate = cookie.get('customer.mytui.web.impersonate.uid')
    const impersonateHeader = impersonate ? { 'x-tui-impersonate-id': impersonate } : {}
    return {
      headers: {
        ...headers,
        authorization: `bearer ${token}`,
        ...impersonateHeader,
      },
    }
  })

  const unauthorizedLink = onError(({ networkError, graphQLErrors }) => {
    if (settings.environment !== 'prod') {
      if (!!networkError) console.log('networkError: ', networkError)

      if (!!graphQLErrors) console.log('graphQLErrors: ', graphQLErrors)
    }
    if (networkError && networkError.statusCode === 401) {
      actions.logout()
    } else if (networkError && networkError.message) {
      setNetworkError(true)
    }
  })

  const uploadLink = createUploadLink({ uri: `${isLoggedIn ? settings.apiAuthorizedGraphqlUrl : settings.apiOpenGraphqlUrl}?brand=${settings.language}` })

  const client = new ApolloClient({
    link: authLink.concat(unauthorizedLink.concat(uploadLink.concat(httpLink))),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        errorPolicy: 'all',
      },
    },
    queryDeduplication: false,
  })

  return (
    <ApolloProvider client={client}>
      <ScrollContext>
        <Switch>
          <Route path="/my-tui" exact render={(e) => <Redirect to={urls.home} />} />

          <AuthRoute path={urls.home} exact>
            <WithHero>
              <Overview />
            </WithHero>
          </AuthRoute>

          <AuthRoute path={urls.privacy}>
            <WithHero>
              <Privacy />
            </WithHero>
          </AuthRoute>
          <AuthRoute path={urls.profile}>
            <WithHero>
              <Preferences />
            </WithHero>
          </AuthRoute>
          <AuthRoute path={urls.ati + '/:bookingNumber'} component={Ati} />
          <AuthRoute path={urls.selfService + '/:bookingNumber'} component={SelfService} />
          <Route component={PageNotFound} />
        </Switch>
      </ScrollContext>
    </ApolloProvider>
  )
}
